import ProductPage from './ProductPage';
import { IframeProductPageRoutes } from './constants'

export default ProductPage;
export {IframeProductPageRoutes};
